import { trialConfig } from "../utils/trialConfig";

export default function TrialTerms() {
  return (
    <div className="p-6 border border-gray-200 bg-gray-50 dark:bg-gray-900 dark:border-gray-800 rounded-xl">
      <h4 className="mb-3 text-lg font-semibold text-gray-900 dark:text-white">
        📄 Syarat & Ketentuan Trial
      </h4>

      <ul className="pl-4 space-y-2 text-sm text-gray-700 list-disc dark:text-gray-300">
        <li>
          Trial berlaku selama {trialConfig.durationDays} hari sejak akun aktif.
        </li>
        <li>Tidak ada pembayaran di awal.</li>
        <li>Trial menggunakan akun & konten asli.</li>
        <li>Tidak wajib melanjutkan setelah trial.</li>
        <li>
          Jika lanjut ke bulan ke-2, biaya hanya Rp{" "}
          {trialConfig.payAfterTrial.toLocaleString()}.
        </li>
        <li>Pembayaran dilakukan setelah masa trial selesai.</li>
      </ul>
    </div>
  );
}
